import React, { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Circle, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// divIcon để tránh lỗi asset marker mặc định của Leaflet trong webpack
const pinIcon = (color) =>
  L.divIcon({
    className: "emp-map-pin",
    html: `<div style="width:20px;height:20px;border-radius:50% 50% 50% 0;background:${color};transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 20],
    popupAnchor: [0, -18],
  });

const userIcon = L.divIcon({
  className: "emp-map-user",
  html: `<div style="width:16px;height:16px;border-radius:50%;background:#1A73E8;border:3px solid #fff;box-shadow:0 0 0 3px rgba(26,115,232,.35)"></div>`,
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

const Recenter = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    if (center?.[0] != null && center?.[1] != null) {
      map.setView(center, map.getZoom(), { animate: true });
    }
  }, [center, map]);
  return null;
};

const CheckInMap = ({
  center, // [lat, lng]
  radius = 200,
  places = [],
  validIds,
  selectedId,
  onSelectPlace,
  height = "340px",
  borderRadius = "12px",
}) => {
  const icons = useMemo(
    () => ({
      selected: pinIcon("#F79D0D"),
      valid: pinIcon("#18C758"),
      normal: pinIcon("#8C97B6"),
    }),
    []
  );

  if (!center) return null;

  return (
    <MapContainer
      center={center}
      zoom={16}
      scrollWheelZoom
      style={{ height, width: "100%", borderRadius, zIndex: 0 }}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Recenter center={center} />

      {/* Bán kính chấm công quanh vị trí hiện tại */}
      <Circle
        center={center}
        radius={radius}
        pathOptions={{ color: "#0094CC", fillColor: "#0094CC", fillOpacity: 0.12 }}
      />

      {/* Vị trí hiện tại */}
      <Marker position={center} icon={userIcon}>
        <Popup>Vị trí của bạn</Popup>
      </Marker>

      {/* Các địa điểm chấm công */}
      {places.map((place, index) => {
        const coords = place?.location?.coordinates;
        if (!Array.isArray(coords) || coords.length < 2) return null;
        const pos = [coords[1], coords[0]];
        const isValid = validIds?.has(place._id);
        const isSelected = selectedId === place._id;
        const icon = isSelected ? icons.selected : isValid ? icons.valid : icons.normal;
        return (
          <Marker
            key={place._id || index}
            position={pos}
            icon={icon}
            eventHandlers={{
              click: () => isValid && onSelectPlace?.(place),
            }}
          >
            <Popup>
              <b>{place.identifier || place.name}</b>
              <br />
              {isValid ? "Trong khu vực chấm công" : "Ngoài bán kính"}
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
};

export default CheckInMap;
